import promise from '../dependencies';

promise.then(() => import('./show-transaction'));
